import { ReactNode } from 'react';
import { FormattedMessageDiv, getError, removeNumbers, useWizardFormContext } from "@odmonorepo/core-components";
import { Form, Stack } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { trackField } from 'merchant-components';

export interface FormRadioProps {
  name?: string;
  required?: boolean;
  nameValues?: Record<string, ReactNode | string>;
  disabled?: boolean;
  inline?: boolean;
  gap?: number;
  options?: string[];
  type?: 'radio' | 'checkbox';
  label?: string | null;
  useYupErrors?: boolean;
  useOptionAsLabel?: boolean;
}

export const FormRadio = ({name = '', label, type = "radio", required = true, inline = true, disabled = false, useYupErrors = false, gap, options = [], useOptionAsLabel = false, nameValues = {}, ...props}: FormRadioProps) => {
  const { register, formState, clearErrors } = useFormContext() || {register: () => {}, formState: {} as any};
  const onInput = (e: any) => e.target.value && clearErrors(name)
  const { formName } = useWizardFormContext();
  const { onBlur: registeredOnBlur, ...restRegister } = register(name);

  return (
    <Stack gap={2}>
      {label !== undefined ? label : <FormattedMessageDiv className="fs-7" id={'formRadio.' + removeNumbers(name) + '.label'} values={nameValues}/>}
      <div>
        <Stack gap={gap ? gap : (inline ? 2 : 2)} direction={inline ? 'horizontal' : 'vertical'}>
          {options.map(o => (
            <Form.Check
              type={type}
              id={name + o}
              value={o}
              key={name + o}
              label={useOptionAsLabel ? o : <FormattedMessageDiv className="fs-7" id={'formRadio.' + removeNumbers(name) + ".option." + o}
              values={{b: (txt: any) => <b>{txt}</b>}}/>}
              required={required}
              onInput={onInput}
              onBlur={(e) => {
                trackField(
                  formName,
                  name as string,
                  'Blur'
                );
                if (registeredOnBlur) {
                  registeredOnBlur(e); // Call the original onBlur from react-hook-form
                }
              }}
              disabled={disabled}
              {...restRegister}
              isInvalid={!!getError(name)}
              form={formName || ''}
            />
          ))}
        </Stack>
        {getError(name) &&
          <div className="text-danger fs-8 mt-2 d-inline-flex align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="me-2 flex-shrink-0"
              width="16"
              height="16"
              viewBox="0 0 12 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              style={{ display: 'block' }}
            >
              <circle cx="6" cy="6" r="5.5"/>
              {/* Exclamation Stem */}
              <path fill="currentColor" stroke="none" d="M5.4 3h1.2l-.2 4h-.8z"/>
              {/* The Dot */}
              <circle cx="6" cy="8.5" r="0.8" fill="currentColor" stroke="none"/>
            </svg>
            <span className="lh-1">{useYupErrors ? getError(name)?.message : <FormattedMessageDiv id='form.selection.error'/>}</span></div>}
          </div>
    </Stack>
  );
}

export default FormRadio;

export const FormCheckboxes = (props: FormRadioProps) => <FormRadio type="checkbox" {...props}/>
